import { ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { SelectedExperienceType } from '../types';

export interface SelectOption {
  label: string;
  value: string;
}

export interface SelectedOptionResult {
  selectedOption: ConfigurationGroupOptionType | null;
  selectedExperienceId: number | null;
  selectedExperienceValue: SelectOption | null;
}

export const getSelectedOptionAndExperienceId = (
  selectableOptionsFormatted: SelectOption[],
  experienceOptionId: number | undefined,
  selectableOptions: ConfigurationGroupOptionType[],
  experiences: { options: SelectedExperienceType[] }
): SelectedOptionResult => {
  const selectedExperienceValue = selectableOptionsFormatted.find(
    (opt) => Number(opt.value) === experienceOptionId
  );

  if (!selectedExperienceValue) {
    return { selectedOption: null, selectedExperienceId: null, selectedExperienceValue: null };
  }

  const selectedOption =
    selectableOptions.find((opt) => opt.id === Number(selectedExperienceValue.value)) ?? null;

  const selectedExperienceId =
    experiences.options.find((exp) => exp.optionId === Number(selectedExperienceValue.value))?.id ??
    null;

  return { selectedOption, selectedExperienceId, selectedExperienceValue };
};
